import Component from '../../classes/Component';
import Swiper, {Lazy, Navigation, Pagination} from "swiper";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";

import {$events} from "../../helpers/events";
import {$style} from "../../helpers/style";

const {breakpoints} = variables;
const rootElId = 'js-landing-reviews';
const controlAttr = 'data-carousel-control';

export default function () {

	return new Component({
		name: 'reviews',
		requiredTargets: '#'+rootElId,
		onInit() {
		    const [rootEl] = this.targets;
		    const controlsOffset = 20;
		    const controls = {
		        prev: $dom.get(`[${controlAttr}="prev"]`, rootEl),
                next: $dom.get(`[${controlAttr}="next"]`, rootEl)
            };

            this.carousel = new Swiper($dom.get('.swiper', rootEl), {
                modules: [Lazy, Navigation, Pagination],
                lazy: {
                    loadedClass: variables.classNames.lazyLoaded,
                    preloaderClass: variables.classNames.lazyPreloader,
                    loadPrevNext: true
                },
                pagination: {
                    el: '#'+rootElId + ' .swiper-pagination',
                    type: 'bullets',
                    dynamicBullets: true
                },
                slidesPerView: 3,
                spaceBetween: 20,
                navigation: {
                    nextEl: controls.next,
                    prevEl: controls.prev
                },
                breakpoints: {
                    [0]: {
                        slidesPerView: 1
                    },
                    [breakpoints.md]: {
                        slidesPerView: 2
                    },
                    [breakpoints.lg]: {
                        slidesPerView: 3
                    }
                }
            });

            this.checkControlsPosition = () => {
                const {prev} = controls;
                const controlsParent = $dom.getParent(prev);
                $style.remove(controlsParent, ['width', 'left', 'zIndex']);
                $style.remove(prev, 'opacity');

                if (controlsParent.getBoundingClientRect().left < controlsOffset) {
                    $style.set(controlsParent, {
                        width: '100%',
                        left: '0',
                        zIndex: '99'
                    });
                }

            }

            this.checkControlsPosition();

            $events.resize('on', this.checkControlsPosition)
        },
		onDestroy() {
            if(this.carousel instanceof Swiper) this.carousel.destroy();
            delete this.carousel;
        }
	})
}
